import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    public logView: boolean = false; // true显示提示组件，false显示编辑组件
    public editView: boolean = false; // true显示修改，false显示新增
    public orgId: string = '';
    public companyId: string = '';
    public departmentQuery: any = [
        {companyId: '123', name: '佩奇的公司1', pcompanyId: null},
        {companyId: '1234', name: '佩奇的公司2', pcompanyId: '123'},
        {companyId: '212', name: '佩奇的公司3', pcompanyId: '123'},
        {companyId: '222', name: '方法的公司4', pcompanyId: '212'},
        {companyId: '333', name: '问的公司5', pcompanyId: '222'}
    ];
    public departmentInfo: any;
    public companyInfo: any;
    public treeDate: any = [];
    public parentId: string;
    searchValue: string = '';
    expandedKeys: any;
    autoExpandParent: any;
    dataList: Array<any> = [];
    companyDetail: {
        address: string;
        city: string;
        companyId: string;
        country: string;
        email: string;
        name: string;
        phone: string;
        taxId: string;
        contactName: string;
    } = {
        address: undefined,
        city: undefined,
        companyId: undefined,
        country: undefined,
        email: undefined,
        name: undefined,
        phone: undefined,
        taxId: undefined,
        contactName: undefined
    };
    countryList: Array<any> = [];
    provinceList: Array<any> = [];
    cityList: Array<any> = [];
    isChina: boolean = true;
    pcompanyId: string = undefined;
}


// WEBPACK FOOTER //
// ./src/display/apps/GroupInfo/Modules.State.ts